import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { verifyFormExists } from '../../../../api/forms';
import {
  ALPHANUMERIC_VALIDATION_TEXT,
  REQUIRED_VALIDATION_TEXT,
  SPECIAL_CHARS,
} from '../../../../constants/Common';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { saveEditor } from '../../../actions/editor.actions';
import { SAVE_ACTION_TYPE } from '../../../constants/editor.constants';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
  confirmModal: {
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveAsModal = ({
  isOpen,
  initialFormName,
  handleClose,
  setIsLoading,
  redirectToAnotherForm,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [formNameForSave, setFormName] = useState(initialFormName);
  const [error, setError] = useState({ hasError: false, errorText: '' });
  const [confirmModalOpen, setConformModalOpen] = useState(false);

  const saveForm = async () => {
    if (confirmModalOpen) {
      setConformModalOpen(false);
    }
    setIsLoading(true);
    await dispatch(
      saveEditor({
        saveAction: SAVE_ACTION_TYPE.SAVE_AS_OTHER_FORM,
        formName: formNameForSave,
        redirectToAnotherForm,
      })
    );
    setIsLoading(false);
    handleClose();
  };

  const handleSaveProgressButton = async () => {
    const isFormExist = await verifyFormExists({ formKey: formNameForSave });

    if (isFormExist) {
      setConformModalOpen(true);
    } else {
      saveForm();
    }
  };

  const handleFormNameFieldBlur = () => {
    const errorObj = { hasError: false, errorText: '' };

    if (!formNameForSave.length) {
      errorObj.hasError = true;
      errorObj.errorText = REQUIRED_VALIDATION_TEXT;
    } else if (SPECIAL_CHARS.test(formNameForSave)) {
      errorObj.hasError = true;
      errorObj.errorText = ALPHANUMERIC_VALIDATION_TEXT;
    } else {
      errorObj.hasError = false;
      errorObj.errorText = '';
    }
    setError(errorObj);
  };

  return (
    <>
      <Modal
        open={isOpen}
        variant="default"
        onClose={handleClose}
        title={translateString('Save As Form')}
        buttonProps={[
          {
            label: translateString('Cancel'),
          },
          {
            label: translateString('Save'),
            onClick: handleSaveProgressButton,
            disabled: error.hasError,
          },
        ]}
        className={classes.modal}
        disableBackdropClick
      >
        <TextField
          label={translateString('Organization')}
          name="organization"
          value="All Organization"
          fullWidth
          disabled
        />
        <TextField
          label={translateString('Form Name')}
          placeholder={translateString('Form Name...')}
          name="formName"
          value={formNameForSave}
          onChange={(e) => setFormName(e.target.value)}
          onBlur={handleFormNameFieldBlur}
          error={error.hasError}
          helperText={error.hasError ? translateString(error.errorText) : null}
          InputProps={{
            inputProps: {
              maxLength: 120,
            },
          }}
          fullWidth
          required
        />
      </Modal>
      {confirmModalOpen && (
        <Modal
          open={confirmModalOpen}
          className={classes.confirmModal}
          variant="warning"
          onClose={() => setConformModalOpen(false)}
          title={translateString('Confirm Save')}
          buttonProps={[
            {
              label: translateString('Cancel'),
            },
            {
              label: translateString('Save'),
              onClick: saveForm,
            },
          ]}
          disableBackdropClick
        >
          <p>
            <b>{formNameForSave} </b>
            {translateString('form already exists. Do you want to overwrite it?')}
          </p>
        </Modal>
      )}
    </>
  );
};

export default SaveAsModal;
